<div class="container" name="bottom">
    <div class="faqs">
        <div class="tw-text-xl md:tw-text-3xl tw-font-extrabold tw-text-center md:tw-pt-10 md:tw-pb-6 tw-pt-8 tw-pb-4">
            Frequently Asked Questions</div>
        <hr class="md:tw-mx-28 tw-mb-8 tw-mx-2 tw-bg-[rgba(0,0,0,0.2)]">
        <div class="row">
            <div class="col-12 tw-pb-10">
                <ul class="faq-titles">
                    <li [ngClass]="{'active': selectedInvestFaqIndex === i}" (click)="onCorporateFaqSelect(i)"
                        *ngFor="let faq of investFaqs; let i = index;">
                        {{faq.title}}
                    </li>
                </ul>
            </div>
            <div class="col-12">
                <div class="accordion" id="accordionExample" *ngIf="selectedInvestFaq">
                    <div class="accordion-item tw-mb-6" *ngFor="let faqs of selectedInvestFaq.faqs; let i = index;">
                        <div class="accordion-header">
                            <button (click)="toggleInvestFaq(i)" class="accordion-button tw-bg-white"
                                [ngClass]="{'collapsed': !faqs.isOpen}" style="color: black;" type="button"
                                data-bs-toggle="expand" data-bs-target="#collapseOne" aria-expanded="true"
                                aria-controls="collapseOne">
                                {{faqs.question}}
                            </button>
                        </div>
                        <div id="collapseOne" class="accordion-collapse collapse" [ngClass]="{'show': faqs.isOpen}"
                            aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <div [innerHTML]="faqs.answer" class="tw-text-sm"></div>

                                <ul *ngIf="faqs.items" class="tw-pl-4">
                                    <li *ngFor="let item of faqs.items"
                                        class="tw-list-disc tw-pl-2 tw-pt-2 tw-text-sm tw-leading-relaxed">
                                        <div [innerHTML]="item"></div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>